"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var AppSettings_1 = tslib_1.__importDefault(require("../../apiServices/auth/AppSettings"));
var Objects_1 = require("../../api/Objects");
var Field_1 = require("../../constants/Field");
var DeepCopy_1 = require("../../models/common/lib/DeepCopy");
var ModelConstants_1 = require("../../constants/ModelConstants");
var lodash_1 = tslib_1.__importStar(require("lodash"));
var ExceptionHandler_1 = require("../../models/common/base/ExceptionHandler");
var Instance_1 = require("../../api/Instance");
var Validator_1 = require("../../models/common/base/Validator");
var SceModel_1 = require("../../models/SceModel");
var Permissions_1 = require("../../apiServices/rbac/permissions/Permissions");
var PermissionsGroup_1 = require("../../apiServices/rbac/group/PermissionsGroup");
var SceCompressedModel_1 = require("../../models/SceCompressedModel/SceCompressedModel");
var EngineeringModel_1 = require("../../api/enggModel/EngineeringModel");
var SceInstance = /** @class */ (function () {
    function SceInstance() {
        this._validator = new Validator_1.Validator();
        this._objectsApi = new Objects_1.Objects();
        this._instanceApi = new Instance_1.Instance();
        this._enggModelApi = new EngineeringModel_1.EngineeringModel();
    }
    SceInstance.prototype.getInstance = function (objectId, assetMonitorModelId, isCod) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var sceInstance, compressedModel, _a, sceCompressedModel, enggError_1, result;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        AppSettings_1.default.verifyUrlInitializationState();
                        PermissionsGroup_1.PermissionsGroup.verifyObjectReadFileDownloadSearch();
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 7, , 8]);
                        compressedModel = void 0;
                        _b.label = 2;
                    case 2:
                        _b.trys.push([2, 4, , 6]);
                        return [4 /*yield*/, this._enggModelApi.GetEnggModel(objectId, ModelConstants_1.ModelConstants.SceInstanceModel)];
                    case 3:
                        compressedModel = _b.sent();
                        return [3 /*break*/, 6];
                    case 4:
                        _a = _b.sent();
                        return [4 /*yield*/, this._objectsApi.getObject(objectId, ModelConstants_1.ModelConstants.SceInstanceModel)];
                    case 5:
                        compressedModel = _b.sent();
                        return [3 /*break*/, 6];
                    case 6:
                        sceCompressedModel = SceCompressedModel_1.SceCompressedModel.fromJson(compressedModel.data, true);
                        sceInstance = sceCompressedModel.properties.getUncompressedModel(assetMonitorModelId);
                        sceInstance[Field_1.FIELD.VERSION] = sceCompressedModel.version;
                        return [3 /*break*/, 8];
                    case 7:
                        enggError_1 = _b.sent();
                        throw new Error(this.handleSceInstanceError(enggError_1));
                    case 8:
                        delete sceInstance[Field_1.FIELD.LASTMODIFIED];
                        result = {
                            status: 200,
                            details: sceInstance
                        };
                        return [2 /*return*/, result];
                }
            });
        });
    };
    /**
     *
     * @param instancesInformation Array of IObject where IObject.objectId is the ObjectId of Instance
     * and IObject.modelId is #.properties.model.model.value from the instance
     */
    SceInstance.prototype.deleteMultipleInstances = function (objectsInfo, isCod) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var objectIdToModelsArray, apiError_1, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        AppSettings_1.default.verifyUrlInitializationState();
                        PermissionsGroup_1.PermissionsGroup.verifyObjectReadWriteDeleteFileUploadDownloadSearchDelete();
                        objectIdToModelsArray = [];
                        lodash_1.map(objectsInfo, function (objectInfo) {
                            var index = lodash_1.findIndex(objectIdToModelsArray, function (o) { return o.key === objectInfo.objectId; });
                            if (index === -1) {
                                objectIdToModelsArray.push({ key: objectInfo.objectId, value: [objectInfo.model] });
                            }
                            else {
                                objectIdToModelsArray[index].value.push(objectInfo.model);
                            }
                        });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, this.stopMonitoringMultipleInstances(objectsInfo)];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.deleteSceInstanceModels(objectIdToModelsArray, isCod)];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        apiError_1 = _a.sent();
                        throw new Error(this.handleSceInstanceError(apiError_1));
                    case 5:
                        result = {
                            status: 200,
                            details: 'Deleted'
                        };
                        return [2 /*return*/, result];
                }
            });
        });
    };
    /**
     *
     * @param models List of models. Each model can have multiple object Id's (properties.objectIds). For update Instance,
     * the array should have only single model and the model should have singe object Id.
     */
    SceInstance.prototype.monitorMultipleInstances = function (models, objectToSceModuleIds, isCod) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var sceModels, result, result, error_1;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        AppSettings_1.default.verifyUrlInitializationState();
                        PermissionsGroup_1.PermissionsGroup.verifyObjectCreateReadWriteFileUploadDownloadSearch();
                        try {
                            lodash_1.map(models, function (model) {
                                var sceModelType = model;
                                var saveOption = sceModelType.properties.saveOption.value;
                                if (saveOption === 'Draft') {
                                    throw new Error('Draft instance is not allowed');
                                }
                                _this._validator.validate(model, true);
                            });
                        }
                        catch (e) {
                            throw e;
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 6, , 7]);
                        console.log("Up sceModels", models);
                        sceModels = lodash_1.map(models, function (model) {
                            return SceModel_1.SceModel.fromJson(model, true);
                        });
                        console.log("After sceModels", sceModels);
                        if (!sceModels[0].objectId) return [3 /*break*/, 3];
                        this._sceModel = sceModels[0];
                        this._model = this._sceModel.rawJson;
                        console.log("After sceModels If cond", sceModels);
                        return [4 /*yield*/, this.monitorExistingInstance(isCod)];
                    case 2:
                        result = _a.sent();
                        return [2 /*return*/, result];
                    case 3:
                        console.log("After sceModels else cond", sceModels);
                        return [4 /*yield*/, this.monitorNewMultipleInstance(sceModels, objectToSceModuleIds)];
                    case 4:
                        result = _a.sent();
                        return [2 /*return*/, result];
                    case 5: return [3 /*break*/, 7];
                    case 6:
                        error_1 = _a.sent();
                        throw new Error(this.handleSceInstanceError(error_1));
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    SceInstance.prototype.updateExistingInstances = function (models, objectToSceModuleIds, isCod) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var sceModels, result, error_2;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        AppSettings_1.default.verifyUrlInitializationState();
                        PermissionsGroup_1.PermissionsGroup.verifyObjectCreateReadWriteFileUploadDownloadSearch();
                        try {
                            lodash_1.map(models, function (model) {
                                var sceModelType = model;
                                var saveOption = sceModelType.properties.saveOption.value;
                                if (saveOption === 'Draft') {
                                    throw new Error('Draft instance is not allowed');
                                }
                                _this._validator.validate(model, true);
                            });
                        }
                        catch (e) {
                            throw e;
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        sceModels = lodash_1.map(models, function (model) {
                            return SceModel_1.SceModel.fromJson(model, true);
                        });
                        return [4 /*yield*/, this.updateMultipleInstance(sceModels, objectToSceModuleIds)];
                    case 2:
                        result = _a.sent();
                        return [2 /*return*/, result];
                    case 3:
                        error_2 = _a.sent();
                        throw new Error(this.handleSceInstanceError(error_2));
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    SceInstance.prototype.disableSingleOrMultipleMonitoringInstances = function (data) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var instance, response, objectIds, result, error_3;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        AppSettings_1.default.verifyUrlInitializationState();
                        PermissionsGroup_1.PermissionsGroup.verifyObjectreadWriteFileUploadDownloadSearch();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        instance = new Instance_1.Instance();
                        return [4 /*yield*/, instance.disableSingleOrMultipleMonitoringInstances(data)];
                    case 2:
                        response = _a.sent();
                        objectIds = lodash_1.map(data, function (o) { return o.objectId; });
                        result = {
                            status: response.status,
                            details: 'Disabled monitoring for ' + objectIds.join()
                        };
                        return [2 /*return*/, result];
                    case 3:
                        error_3 = _a.sent();
                        throw new Error(this.handleSceInstanceError(error_3));
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    SceInstance.prototype.enableSingleOrMultipleMonitoringInstances = function (data) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var instance, response, objectIds, result, error_4;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        AppSettings_1.default.verifyUrlInitializationState();
                        PermissionsGroup_1.PermissionsGroup.verifyObjectreadWriteFileUploadDownloadSearch();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        instance = new Instance_1.Instance();
                        return [4 /*yield*/, instance.enableSingleOrMultipleMonitoringInstances(data)];
                    case 2:
                        response = _a.sent();
                        objectIds = lodash_1.map(data, function (o) { return o.objectId; });
                        result = {
                            status: response.status,
                            details: 'Enabled monitoring for ' + objectIds.join()
                        };
                        return [2 /*return*/, result];
                    case 3:
                        error_4 = _a.sent();
                        throw new Error(this.handleSceInstanceError(error_4));
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    SceInstance.prototype.restoreSce = function (edgeId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._objectsApi.restoreSce(edgeId)];
                    case 1:
                        response = _a.sent();
                        result = {
                            status: response.status,
                            details: response.data
                        };
                        return [2 /*return*/, result];
                }
            });
        });
    };
    /**
     * Gets list of instances for given modelId from info model
     * @param modelId
     */
    SceInstance.prototype.getInfoModelInstances = function (modelId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response, result, error_5;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        Permissions_1.rbacPermissions.verifyObjectReadPermission();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this._objectsApi.queryForModel(modelId)];
                    case 2:
                        response = _a.sent();
                        result = {
                            status: response.status,
                            details: response.data.data
                        };
                        return [2 /*return*/, result];
                    case 3:
                        error_5 = _a.sent();
                        throw new Error(this.handleSceInstanceError(error_5));
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    SceInstance.prototype.getSCECleanupInstances = function (edgeId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response, result, error_6;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        Permissions_1.rbacPermissions.verifyObjectReadPermission();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this._instanceApi.getSCECleanupInstances(edgeId)];
                    case 2:
                        response = _a.sent();
                        result = {
                            status: response.status,
                            details: response.data
                        };
                        return [2 /*return*/, result];
                    case 3:
                        error_6 = _a.sent();
                        throw new Error(this.handleSceInstanceError(error_6));
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    SceInstance.prototype.updateInfoModelInstance = function (objectId, modelId, value) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response, result, error_7;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        Permissions_1.rbacPermissions.verifyObjectWritePermission();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this._objectsApi.updateObject(objectId, modelId, JSON.stringify(value))];
                    case 2:
                        response = _a.sent();
                        result = {
                            status: response.status,
                            details: response.data
                        };
                        return [2 /*return*/, result];
                    case 3:
                        error_7 = _a.sent();
                        throw new Error(this.handleSceInstanceError(error_7));
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    SceInstance.prototype.deleteInfoModelInstance = function (objectId, modelId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response, result, error_8;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        Permissions_1.rbacPermissions.verifyObjectDeletePermission();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this._objectsApi.deleteObject(objectId, modelId)];
                    case 2:
                        response = _a.sent();
                        result = {
                            status: response.status,
                            details: response.data
                        };
                        return [2 /*return*/, result];
                    case 3:
                        error_8 = _a.sent();
                        throw new Error(this.handleSceInstanceError(error_8));
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    SceInstance.prototype.saveInfoModelInstance = function (value) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response, result, error_9;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        Permissions_1.rbacPermissions.verifyObjectCreatePermission();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this._objectsApi.saveObject(JSON.stringify(value))];
                    case 2:
                        response = _a.sent();
                        result = {
                            status: response.status,
                            details: response.data
                        };
                        return [2 /*return*/, result];
                    case 3:
                        error_9 = _a.sent();
                        throw new Error(this.handleSceInstanceError(error_9));
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    SceInstance.prototype.updateRelatedInstances = function (functionType) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response, result, error_10;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        PermissionsGroup_1.PermissionsGroup.verifyObjectCreateReadWriteFileUploadDownloadSearch();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this._instanceApi.updateRelatedInstances(functionType, false)];
                    case 2:
                        response = _a.sent();
                        result = {
                            status: response.status,
                            details: response.data
                        };
                        return [2 /*return*/, result];
                    case 3:
                        error_10 = _a.sent();
                        throw new Error(this.handleSceInstanceError(error_10));
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    SceInstance.prototype.updateTypeRelatedInstances = function (typeInfo) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response, result, error_11;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        PermissionsGroup_1.PermissionsGroup.verifyObjectCreateReadWriteFileUploadDownloadSearch();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this._instanceApi.updateRelatedInstances(typeInfo, true)];
                    case 2:
                        response = _a.sent();
                        result = {
                            status: response.status,
                            details: response.data
                        };
                        return [2 /*return*/, result];
                    case 3:
                        error_11 = _a.sent();
                        throw new Error(this.handleSceInstanceError(error_11));
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    SceInstance.prototype.getObjectVariables = function (objectId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response, filteredInput, result, error_12;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        Permissions_1.rbacPermissions.verifyTypeDefReadPermission();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this._instanceApi.getObjectVariables(objectId)];
                    case 2:
                        response = _a.sent();
                        filteredInput = [];
                        if (response != null) {
                            filteredInput = response.data.filter(function (x) { return !x.name.includes('.outputs.'); });
                        }
                        result = {
                            status: response.status,
                            details: filteredInput
                        };
                        return [2 /*return*/, result];
                    case 3:
                        error_12 = _a.sent();
                        throw new Error(this.handleSceInstanceError(error_12));
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    // TODO: Adding new model on a configured instance
    SceInstance.prototype.monitorNewMultipleInstance = function (sceModels, objectToSceModuleIds) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var sceEnggModels, sceKeyValueData, sceNoAlarmData, isError, objectToModels, instances, instancePromises, cloneInstances, monitorInstanceResponse, mapPromises, result;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        sceEnggModels = [];
                        sceKeyValueData = [];
                        sceNoAlarmData = [];
                        isError = false;
                        lodash_1.map(sceModels, function (sceModel) {
                            var models = lodash_1.map(sceModel.properties.objectIds.value, function (objectId) {
                                var clone = DeepCopy_1.deepCopy(sceModel.rawJson);
                                clone.properties.objectIds.value = [objectId];
                                clone.objectId = objectId;
                                return clone;
                            });
                            sceEnggModels = sceEnggModels.concat(models);
                        });
                        objectToModels = [];
                        lodash_1.map(sceEnggModels, function (sceModel) {
                            var objectIdIndex = lodash_1.findIndex(objectToModels, function (keyValue) { return keyValue.key === sceModel.objectId; });
                            if (objectIdIndex === -1) {
                                var objectToModel = { key: sceModel.objectId, value: [sceModel] };
                                objectToModels.push(objectToModel);
                            }
                            else {
                                objectToModels[objectIdIndex].value.push(sceModel);
                            }
                        });
                        console.log("Inside sceEnggModels", sceEnggModels);
                        console.log("Inside sceEnggModels JSONSTRING", JSON.stringify(sceEnggModels));
                        console.log("Up sceModels", sceModels);
                        instances = [];
                        instancePromises = lodash_1.map(sceModels, function (sceModel) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            var instancesPerModel;
                            return tslib_1.__generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, sceModel.toComputeInstanceJsons()];
                                    case 1:
                                        instancesPerModel = _a.sent();
                                        instances = instances.concat(instancesPerModel);
                                        return [2 /*return*/];
                                }
                            });
                        }); });
                        return [4 /*yield*/, Promise.all(instancePromises)];
                    case 1:
                        _a.sent();
                        console.log("After instances", instances);
                        cloneInstances = lodash_1.cloneDeep(instances);
                        cloneInstances.forEach(function (instance) {
                            var isIndexExist = sceKeyValueData.findIndex(function (x) { return x.key == instance.type; });
                            if (isIndexExist < 0)
                                sceKeyValueData.push({ key: instance.type, value: instance.properties });
                        });
                        console.log("Inside sceKeyValueData", sceKeyValueData);
                        try {
                            sceNoAlarmData = exports.checkForEmptyAlarms(sceKeyValueData, sceNoAlarmData);
                        }
                        catch (e) {
                            console.log("Error :: ", e);
                            isError = true;
                        }
                        console.log("Inside sceNoAlarmData", sceNoAlarmData);
                        // Set Output if alarm is empty
                        try {
                            cloneInstances = exports.setOutputForEmptyAlarms(cloneInstances, sceNoAlarmData);
                        }
                        catch (e) {
                            console.log("Error :: ", e);
                            isError = true;
                        }
                        console.log("Inside cloneInstances", cloneInstances);
                        return [4 /*yield*/, SceModel_1.SceModel.monitorInstances(isError ? instances : cloneInstances, objectToSceModuleIds)];
                    case 2:
                        monitorInstanceResponse = _a.sent();
                        mapPromises = lodash_1.map(objectToModels, function (objectToModel) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            var sceCompressedModelResponse, _a, sceCompressedModel_1, sceCompressedModel;
                            return tslib_1.__generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0:
                                        _b.trys.push([0, 2, , 4]);
                                        return [4 /*yield*/, this._objectsApi.getObject(objectToModel.key, ModelConstants_1.ModelConstants.SceInstanceModel)];
                                    case 1:
                                        sceCompressedModelResponse = _b.sent();
                                        console.log("try sceCompressedModelResponse", sceCompressedModelResponse);
                                        return [3 /*break*/, 4];
                                    case 2:
                                        _a = _b.sent();
                                        return [4 /*yield*/, this._enggModelApi.GetEnggModel(objectToModel.key, ModelConstants_1.ModelConstants.SceInstanceModel).catch(function (err) {
                                                return undefined;
                                            })];
                                    case 3:
                                        sceCompressedModelResponse = _b.sent();
                                        console.log("catch sceCompressedModelResponse", sceCompressedModelResponse);
                                        return [3 /*break*/, 4];
                                    case 4:
                                        if (!sceCompressedModelResponse) return [3 /*break*/, 6];
                                        console.log("inside sceCompressedModelResponse", sceCompressedModelResponse);
                                        sceCompressedModel_1 = SceCompressedModel_1.SceCompressedModel.fromJson(sceCompressedModelResponse.data, true);
                                        lodash_1.map(objectToModel.value, function (model) {
                                            var modelDetails = model.properties.model;
                                            console.log("inside objectToModel.value", model);
                                            sceCompressedModel_1.properties.addModel(modelDetails.model.value, modelDetails.typeId.value, modelDetails.version.value, modelDetails.name.value, SceModel_1.SceModel.clearNonOverriddenConditions(model));
                                        });
                                        return [4 /*yield*/, sceCompressedModel_1.updateCompressedModel(true)];
                                    case 5:
                                        _b.sent();
                                        return [3 /*break*/, 8];
                                    case 6:
                                        sceCompressedModel = SceCompressedModel_1.SceCompressedModel.createSceCompressedJson(lodash_1.map(objectToModel.value, function (v) { return SceModel_1.SceModel.clearNonOverriddenConditions(v); }), true);
                                        return [4 /*yield*/, sceCompressedModel.saveCompressedModel(true)];
                                    case 7:
                                        _b.sent();
                                        _b.label = 8;
                                    case 8: return [2 /*return*/];
                                }
                            });
                        }); });
                        return [4 /*yield*/, Promise.all(mapPromises)];
                    case 3:
                        _a.sent();
                        result = {
                            status: 200,
                            details: monitorInstanceResponse
                        };
                        return [2 /*return*/, result];
                }
            });
        });
    };
    SceInstance.prototype.updateMultipleInstance = function (sceModels, objectToSceModuleIds) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var sceEnggModels, sceKeyValueData, sceNoAlarmData, isError, objectToModels, instances, instancePromises, cloneInstances, monitorInstanceResponse, mapPromises, result;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        sceEnggModels = [];
                        sceKeyValueData = [];
                        sceNoAlarmData = [];
                        isError = false;
                        lodash_1.map(sceModels, function (sceModel) {
                            var models = lodash_1.map(sceModel.properties.objectIds.value, function (objectId) {
                                var clone = DeepCopy_1.deepCopy(sceModel.rawJson);
                                clone.properties.objectIds.value = [objectId];
                                clone.objectId = objectId;
                                return clone;
                            });
                            sceEnggModels = sceEnggModels.concat(models);
                        });
                        objectToModels = [];
                        lodash_1.map(sceEnggModels, function (sceModel) {
                            var objectIdIndex = lodash_1.findIndex(objectToModels, function (keyValue) { return keyValue.key === sceModel.objectId; });
                            if (objectIdIndex === -1) {
                                var objectToModel = { key: sceModel.objectId, value: [sceModel] };
                                objectToModels.push(objectToModel);
                            }
                            else {
                                objectToModels[objectIdIndex].value.push(sceModel);
                            }
                        });
                        console.log("Inside sceEnggModels", sceEnggModels);
                        console.log("Inside sceEnggModels JSONSTRING", JSON.stringify(sceEnggModels));
                        instances = [];
                        instancePromises = lodash_1.map(sceModels, function (sceModel) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            var instancesPerModel;
                            return tslib_1.__generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, sceModel.toComputeInstanceJsons()];
                                    case 1:
                                        instancesPerModel = _a.sent();
                                        instances = instances.concat(instancesPerModel);
                                        return [2 /*return*/];
                                }
                            });
                        }); });
                        return [4 /*yield*/, Promise.all(instancePromises)];
                    case 1:
                        _a.sent();
                        console.log("After instances", instances);
                        cloneInstances = lodash_1.cloneDeep(instances);
                        cloneInstances.forEach(function (instance) {
                            var isIndexExist = sceKeyValueData.findIndex(function (x) { return x.key == instance.type; });
                            if (isIndexExist < 0)
                                sceKeyValueData.push({ key: instance.type, value: instance.properties });
                        });
                        console.log("Inside sceKeyValueData", sceKeyValueData);
                        try {
                            sceNoAlarmData = exports.checkForEmptyAlarms(sceKeyValueData, sceNoAlarmData);
                        }
                        catch (e) {
                            console.log("Error :: ", e);
                            isError = true;
                        }
                        console.log("Inside sceNoAlarmData", sceNoAlarmData);
                        // Set Output if alarm is empty
                        try {
                            cloneInstances = exports.setOutputForEmptyAlarms(cloneInstances, sceNoAlarmData);
                        }
                        catch (e) {
                            console.log("Error :: ", e);
                            isError = true;
                        }
                        console.log("Inside cloneInstances", cloneInstances);
                        return [4 /*yield*/, SceModel_1.SceModel.updateInstances(isError ? instances : cloneInstances, objectToSceModuleIds)];
                    case 2:
                        monitorInstanceResponse = _a.sent();
                        console.log("monitorInstanceResponse", monitorInstanceResponse);
                        mapPromises = lodash_1.map(objectToModels, function (objectToModel) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            var sceCompressedModelResponse, _a, sceCompressedModel_2;
                            return tslib_1.__generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0:
                                        console.log("objectToModels", objectToModels);
                                        _b.label = 1;
                                    case 1:
                                        _b.trys.push([1, 3, , 5]);
                                        return [4 /*yield*/, this._objectsApi.getObject(objectToModel.key, ModelConstants_1.ModelConstants.SceInstanceModel)];
                                    case 2:
                                        sceCompressedModelResponse = _b.sent();
                                        console.log("sceCompressedModelResponse _objectsApi", sceCompressedModelResponse);
                                        return [3 /*break*/, 5];
                                    case 3:
                                        _a = _b.sent();
                                        return [4 /*yield*/, this._enggModelApi.GetEnggModel(objectToModel.key, ModelConstants_1.ModelConstants.SceInstanceModel).catch(function (err) {
                                                return undefined;
                                            })];
                                    case 4:
                                        sceCompressedModelResponse = _b.sent();
                                        console.log("sceCompressedModelResponse _enggModelApi", sceCompressedModelResponse);
                                        return [3 /*break*/, 5];
                                    case 5:
                                        if (!sceCompressedModelResponse) return [3 /*break*/, 7];
                                        sceCompressedModel_2 = SceCompressedModel_1.SceCompressedModel.fromJson(sceCompressedModelResponse.data, true);
                                        lodash_1.map(objectToModel.value, function (model) {
                                            var modelDetails = model.properties.model;
                                            // sceCompressedModel.properties.addModel(modelDetails.model.value, modelDetails.typeId.value, modelDetails.version.value, modelDetails.name.value, SceModel.clearNonOverriddenConditions(model));
                                            sceCompressedModel_2.properties.updateContentForModel(modelDetails.model.value, SceModel_1.SceModel.clearNonOverriddenConditions(DeepCopy_1.deepCopy(model)));
                                        });
                                        return [4 /*yield*/, sceCompressedModel_2.updateCompressedModel(true)];
                                    case 6:
                                        _b.sent();
                                        console.log("sceCompressedModelResponse updateCompressedModel", sceCompressedModelResponse);
                                        _b.label = 7;
                                    case 7: return [2 /*return*/];
                                }
                            });
                        }); });
                        return [4 /*yield*/, Promise.all(mapPromises)];
                    case 3:
                        _a.sent();
                        result = {
                            status: 200,
                            details: monitorInstanceResponse
                        };
                        return [2 /*return*/, result];
                }
            });
        });
    };
    // Asumption: properties.objectIds.values will have only single objectId
    SceInstance.prototype.monitorExistingInstance = function (isCod) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var sceCompressedModelResponse, _a, sceCompressedModel, instanceResponse, model, result;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 4]);
                        return [4 /*yield*/, this._objectsApi.getObject(this._sceModel.objectId, ModelConstants_1.ModelConstants.SceInstanceModel)];
                    case 1:
                        sceCompressedModelResponse = _b.sent();
                        return [3 /*break*/, 4];
                    case 2:
                        _a = _b.sent();
                        return [4 /*yield*/, this._enggModelApi.GetEnggModel(this._sceModel.objectId, ModelConstants_1.ModelConstants.SceInstanceModel)];
                    case 3:
                        sceCompressedModelResponse = _b.sent();
                        return [3 /*break*/, 4];
                    case 4:
                        sceCompressedModel = SceCompressedModel_1.SceCompressedModel.fromJson(sceCompressedModelResponse.data, true);
                        sceCompressedModel.properties.updateContentForModel(this._sceModel.properties.model.model.value, SceModel_1.SceModel.clearNonOverriddenConditions(DeepCopy_1.deepCopy(this._model)));
                        return [4 /*yield*/, this._sceModel.startMonitoringExistingInstance()];
                    case 5:
                        instanceResponse = _b.sent();
                        return [4 /*yield*/, sceCompressedModel.updateCompressedModel(true)];
                    case 6:
                        _b.sent();
                        model = this._model;
                        model.version = model.version + 1;
                        result = {
                            status: 200,
                            details: [instanceResponse]
                        };
                        return [2 /*return*/, result];
                }
            });
        });
    };
    SceInstance.prototype.stopMonitoringMultipleInstances = function (objectsInfo) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var instance, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        instance = new Instance_1.Instance();
                        return [4 /*yield*/, instance.stopMonitoringMultipleInstances(objectsInfo)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    SceInstance.prototype.deleteSceInstanceModels = function (objectIdToModelsArray, isCod) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var deletePromises;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        deletePromises = lodash_1.map(objectIdToModelsArray, function (objectIdToModels) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            var sceCompressedModelJsonResponse, _a, sceCompressedModel_3, _b;
                            var _this = this;
                            return tslib_1.__generator(this, function (_c) {
                                switch (_c.label) {
                                    case 0:
                                        _c.trys.push([0, 10, , 11]);
                                        sceCompressedModelJsonResponse = void 0;
                                        _c.label = 1;
                                    case 1:
                                        _c.trys.push([1, 3, , 5]);
                                        return [4 /*yield*/, this._enggModelApi.GetEnggModel(objectIdToModels.key, ModelConstants_1.ModelConstants.SceInstanceModel)];
                                    case 2:
                                        sceCompressedModelJsonResponse = _c.sent();
                                        return [3 /*break*/, 5];
                                    case 3:
                                        _a = _c.sent();
                                        return [4 /*yield*/, this._objectsApi.getObject(objectIdToModels.key, ModelConstants_1.ModelConstants.SceInstanceModel)];
                                    case 4:
                                        sceCompressedModelJsonResponse = _c.sent();
                                        return [3 /*break*/, 5];
                                    case 5:
                                        sceCompressedModel_3 = SceCompressedModel_1.SceCompressedModel.fromJson(sceCompressedModelJsonResponse.data, true);
                                        lodash_1.map(objectIdToModels.value, function (assetMonitorModel) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                                            return tslib_1.__generator(this, function (_a) {
                                                sceCompressedModel_3.properties.removeModel(assetMonitorModel);
                                                return [2 /*return*/];
                                            });
                                        }); });
                                        if (!(sceCompressedModel_3.properties.models.length === 0)) return [3 /*break*/, 7];
                                        return [4 /*yield*/, sceCompressedModel_3.deleteCompressedModel(true)];
                                    case 6:
                                        _c.sent();
                                        return [3 /*break*/, 9];
                                    case 7: return [4 /*yield*/, sceCompressedModel_3.updateCompressedModel(true)];
                                    case 8:
                                        _c.sent();
                                        _c.label = 9;
                                    case 9: return [3 /*break*/, 11];
                                    case 10:
                                        _b = _c.sent();
                                        return [3 /*break*/, 11];
                                    case 11: return [2 /*return*/];
                                }
                            });
                        }); });
                        return [4 /*yield*/, Promise.all(deletePromises)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    SceInstance.prototype.handleSceInstanceError = function (error) {
        var exceptionHandler = new ExceptionHandler_1.ExceptionHandler();
        return JSON.stringify(exceptionHandler.buildExceptionFromError(error));
    };
    return SceInstance;
}());
exports.SceInstance = SceInstance;
exports.setOutputForEmptyAlarms = function (cloneInstances, sceNoAlarmData) {
    if (cloneInstances.length > 0 && sceNoAlarmData.length > 0) {
        cloneInstances.forEach(function (item, index) {
            var npData = sceNoAlarmData.find(function (x) { return x.key == item.type; });
            console.log("Inside npData", npData);
            if (npData && npData.functionData) {
                Object.keys(npData.functionData).forEach(function (key) {
                    var data = npData.noAlarmData.find(function (x) { return x.key == key; });
                    if (data) {
                        var value = data.value;
                        var outputs = {
                            "outputs": {
                                "conditions": value
                            }
                        };
                        console.log("Inside data", data);
                        console.log("Inside outputs", outputs);
                        Object.assign(cloneInstances[index].properties.functions[key], outputs);
                    }
                });
            }
        });
    }
    return cloneInstances;
};
exports.checkForEmptyAlarms = function (sceKeyValueData, sceNoAlarmData) {
    if (sceKeyValueData.length > 0) {
        var functionAlarmEmptyData_1 = [];
        sceKeyValueData.forEach(function (item) {
            var alarms = lodash_1.default.get(item, "value.alarms");
            if (alarms) {
                var uniqueItem = [];
                console.log("Inside alarms", alarms);
                Object.keys(alarms).forEach(function (key) {
                    var objKey = alarms[key];
                    if (objKey) {
                        Object.keys(objKey).forEach(function (item) {
                            var itemValue = objKey[item];
                            if (itemValue) {
                                if (!itemValue.value && !uniqueItem.includes(key)) {
                                    var alarmData = {};
                                    Object.keys(objKey).forEach(function (data) {
                                        var _a, _b;
                                        var newKey = data + "Alarm";
                                        var newObj = (_a = {},
                                            _a[data] = (_b = {},
                                                _b[newKey] = {
                                                    "objectLink": "",
                                                    "value": ""
                                                },
                                                _b),
                                            _a);
                                        Object.assign(alarmData, newObj);
                                    });
                                    functionAlarmEmptyData_1.push({ key: key, value: alarmData });
                                    uniqueItem.push(key);
                                }
                            }
                        });
                    }
                });
            }
            console.log("Inside functionAlarmEmptyData", functionAlarmEmptyData_1);
            var functions = lodash_1.default.get(item, "value.functions");
            if (functionAlarmEmptyData_1.length > 0)
                sceNoAlarmData.push({ key: item.key, noAlarmData: functionAlarmEmptyData_1, functionData: functions });
        });
    }
    return sceNoAlarmData;
};
//# sourceMappingURL=SceInstance.js.map